type TrustedValue = string | object;

interface TrustedTypesWindow extends Window {
  trustedTypes?: {
    createPolicy: (
      name: string,
      rules: {
        createScript?: (value: string) => string;
        createScriptURL?: (value: string) => string;
      },
    ) => {
      createScript?: (value: string) => object;
      createScriptURL?: (value: string) => object;
    };
  };
}

const SCRIPT_POLICY_NAME = 'lumivraz#scripts';
const JSONLD_POLICY_NAME = 'lumivraz#jsonld';

const ALLOWED_SCRIPT_ORIGINS = new Set([
  'https://accounts.google.com',
  'https://cdn.onesignal.com',
  'https://pagead2.googlesyndication.com',
  'https://sdk.mercadopago.com',
  'https://securepubads.g.doubleclick.net',
  'https://www.googletagmanager.com',
  'https://www.mercadopago.com',
]);

let scriptPolicy:
  | {
      createScriptURL?: (value: string) => object;
    }
  | undefined;
let jsonLdPolicy:
  | {
      createScript?: (value: string) => object;
    }
  | undefined;

export function trustedScriptUrl(value: string): TrustedValue {
  const trustedTypes = getTrustedTypes();
  if (!trustedTypes) return value;

  scriptPolicy ??= trustedTypes.createPolicy(SCRIPT_POLICY_NAME, {
    createScriptURL: (input) => {
      const url = new URL(input, window.location.origin);
      if (
        url.origin !== window.location.origin &&
        !ALLOWED_SCRIPT_ORIGINS.has(url.origin)
      ) {
        throw new TypeError(`Script origin not allowed: ${url.origin}`);
      }
      return url.href;
    },
  });

  return scriptPolicy.createScriptURL?.(value) ?? value;
}

export function trustedJsonLd(value: string): TrustedValue {
  const trustedTypes = getTrustedTypes();
  if (!trustedTypes) return value;

  jsonLdPolicy ??= trustedTypes.createPolicy(JSONLD_POLICY_NAME, {
    createScript: (input) => input,
  });

  return jsonLdPolicy.createScript?.(value) ?? value;
}

function getTrustedTypes() {
  if (typeof window === 'undefined') return undefined;
  return (window as TrustedTypesWindow).trustedTypes;
}
